import { ZonedDateTime } from '@js-joda/core';
import clsx from 'clsx';

import { SignatureInput, type SignatureInputOnChange, type SignatureType } from '#/shared/components/SignatureInput';

import { FormFieldLabel } from './FormFieldLabel';
import { FormFieldSupportingText } from './FormFieldSupportingText';
import {
  type FormFieldDescriptionProps,
  type FormFieldErrorProps,
  type FormFieldLabelProps,
  type FormFieldStyleProps,
} from './types';

type SignatureFieldProps = FormFieldLabelProps &
  Omit<FormFieldDescriptionProps, 'descriptionPosition'> &
  FormFieldErrorProps &
  FormFieldStyleProps & {
    labelFor?: string;
    value?: string;
    signedAt?: ZonedDateTime;
    signatureType?: SignatureType;
    onChange: SignatureInputOnChange;
  };

export const SignatureField = ({
  value,
  signedAt,
  signatureType,
  label,
  labelFor,
  description,
  descriptionLeadingIconName,
  errorMessage,
  errorLeadingIconName,
  onChange,
  className,
}: SignatureFieldProps) => {
  return (
    <div className={clsx('relative w-full', className)}>
      {label && <FormFieldLabel htmlFor={labelFor}>{label}</FormFieldLabel>}

      <SignatureInput
        value={value}
        signedAt={signedAt}
        signatureType={signatureType}
        isError={!!errorMessage}
        onChange={onChange}
      />

      {description && (
        <FormFieldSupportingText leadingIconName={descriptionLeadingIconName}>{description}</FormFieldSupportingText>
      )}

      {errorMessage && (
        <FormFieldSupportingText leadingIconName={errorLeadingIconName} isError>
          {errorMessage}
        </FormFieldSupportingText>
      )}
    </div>
  );
};
